module.exports = __webpack_public_path__ + "img/storyboard_lite_presets.dab619c3.webp";